import { useState } from 'react'
import { useAuth } from '../auth/AuthProvider'
import { errorMessage } from '../api/client'
import { Field } from '../components/ui'

export function LoginPage() {
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [totp, setTotp] = useState('')
  const [totpRequired, setTotpRequired] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await login(email, password, totp || undefined)
    } catch (caught) {
      const details =
        caught && typeof caught === 'object' && 'error' in caught
          ? (caught as { error?: { details?: { totp_required?: boolean } } }).error?.details
          : undefined
      if (details?.totp_required) setTotpRequired(true)
      setError(errorMessage(caught, 'Anmeldung fehlgeschlagen.'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="mx-auto flex min-h-full max-w-sm flex-col justify-center px-4 py-12">
      <h1 className="font-display text-3xl">Backoffice</h1>
      <p className="mb-6 mt-1 text-sm text-paper-500">Bitte anmelden.</p>

      <form onSubmit={submit} className="card" noValidate>
        {error ? (
          <p role="alert" className="mb-4 rounded-md bg-red-50 p-3 text-sm text-red-900 dark:bg-red-950/50 dark:text-red-100">
            {error}
          </p>
        ) : null}
        <Field label="E-Mail">
          {(props) => (
            <input
              {...props}
              className="input"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          )}
        </Field>
        <Field label="Passwort">
          {(props) => (
            <input
              {...props}
              className="input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          )}
        </Field>
        {totpRequired ? (
          <Field label="Bestätigungscode" hint="Sechsstelliger Code aus der Authenticator-App.">
            {(props) => (
              <input
                {...props}
                className="input"
                inputMode="numeric"
                autoComplete="one-time-code"
                value={totp}
                onChange={(event) => setTotp(event.target.value)}
              />
            )}
          </Field>
        ) : null}
        <button type="submit" className="btn-primary w-full" disabled={busy}>
          {busy ? 'Wird angemeldet…' : 'Anmelden'}
        </button>
      </form>

      {/* The form cannot say whether the address or the password was wrong, so a
          forgotten address looks like a forgotten password. Both end up here. */}
      <details className="mt-6 text-sm text-paper-500">
        <summary className="cursor-pointer">Passwort oder Adresse vergessen?</summary>
        <p className="mt-2">
          Es gibt keine Zurücksetz-Mail — der Ausweis ist der Zugang zum Server selbst:
        </p>
        <pre className="mt-2 overflow-x-auto rounded-md bg-paper-100 p-3 font-mono text-xs dark:bg-paper-900">
          {'docker compose exec api python -m cli.main user list\n'}
          {'docker compose exec api python -m cli.main user reset-password <adresse>'}
        </pre>
      </details>
    </div>
  )
}
